
<template>


    <div ref="MessageWindow" style="z-index:2000">


        <table v-for="messageInfo in this.MessageInfoList"
               :style="{left: messageInfo.Left , top : messageInfo.Top , width : messageInfo.Width , zIndex:messageInfo.zIndex ,}"
               class="MessageWindow "
               
               :class="CssClass(messageInfo)">

            <tr>
                <td valign="middle" align="center">
                    <span class="Description" v-html="messageInfo.Description"></span>

                </td>
            </tr>
        </table>


    </div>

</template>

<script scoped>

    function WindowLayout() {
        this.X = 0;
        this.Y = 0;
        this.Width = 0;
        this.Height = 0;
    }

    export default {
        data() {
            return {
                Left: "0px",
                Top: "0px",
                Width: "100px",
                Height: "100px",
                MessageInfoList: [],
                MessageCheckerRunning: false
            }
        }
        ,

        methods: {

            SetShowing() {
                let messageInfo;
                let showingCount = 0;
                let i;


                //console.log("MessageWindow : this.SetShowing()");

                for (i = 0; i < this.MessageInfoList.length; i++) {
                    messageInfo = this.MessageInfoList[i];

                    if (messageInfo.State == "Ready") {
                        messageInfo.Visible = true;
                        messageInfo.State = "Showing";

                        //console.log("MessageWindow : messageInfo.State = 'Showing'");

                        showingCount++;
                    }
                }//end for (i = 0; i < this.MessageInfoList.length; i++) {

                this.$forceUpdate();
            },

            MessageChecker() {
                let messageInfo;
                let currTime;
                let readyCount = 0, showingCount = 0, fadeOutCount = 0, finishedCount = 0;
                let i;


                this.MessageCheckerRunning = true;

                currTime = new Date();

            

                for (i = 0; i < this.MessageInfoList.length; i++) {
                    messageInfo = this.MessageInfoList[i];

                    if (messageInfo.State == "Ready") {
                        readyCount++;
                        //console.log("MessageWindow : State=='Ready',readyCount="+readyCount);
                    }
                    else if (messageInfo.State == "Showing") {
                        //console.log("MessageWindow : State=='Showing'");
                        if ((currTime - messageInfo.CreateTime) > messageInfo.Duration) {
                            //console.log("MessageWindow :  messageInfo.State = FadeOut");
                            messageInfo.State = "FadeOut";
                            fadeOutCount++;
                        }
                        else {
                            //console.log("MessageWindow :  showingCount++");
                            showingCount++;
                        }
                    }
                    else if (messageInfo.State == "FadeOut") {
                        //console.log("MessageWindow :  messageInfo.State == 'FadeOut'");

                        if ((currTime - messageInfo.CreateTime) > (messageInfo.Duration + 1000)) {
                            //console.log("MessageWindow :  messageInfo.State == 'Finished'");
                            messageInfo.State = "Finished";
                            finishedCount++;
                        }
                        else {
                            //console.log("MessageWindow : fadeOutCount++");
                            fadeOutCount++;
                        }
                    }
                }//end for (i = 0; i < this.MessageInfoList.length; i++) {

                if (readyCount > 0) {
                    //console.log("MessageWindow : readyCount > 0");

                    setTimeout(
                        function () {
                            //console.log("MessageWindow : this.SetShowing()");
                            this.SetShowing();
                        }.bind(this)
                        ,
                        100
                    );
                }

                if (readyCount > 0 || showingCount > 0 || fadeOutCount > 0) {
                    setTimeout(
                        function () {
                            //console.log("MessageWindow : this.MessageChecker()");
                            this.MessageChecker();
                        }.bind(this)
                        ,
                        100
                    );
                }
                else {
                    //Stop Check
                    this.MessageCheckerRunning = false;
                    this.MessageInfoList = [];
                }//end if (visibleMessageCount > 0) {

            }//end  MessageChecker() {
            ,

            OnReceiveMessage(messageText, duration) {
                let windowLayout;
                let messageInfo = {};


                if (duration == null) {
                    duration = 2000;
                }

                windowLayout = this.GetCenterWindowLayout(300, 200);


                messageInfo.Left = windowLayout.X + (this.MessageInfoList.length * 10) + "px";
                messageInfo.Top = windowLayout.Y + (this.MessageInfoList.length * 10) + 10 + "px";
                messageInfo.Width = windowLayout.Width + "px";
                messageInfo.Height = windowLayout.Height + "px";


                messageInfo.State = "Ready";
                messageInfo.Duration = duration;
                messageInfo.Description = messageText;
                messageInfo.CreateTime = new Date();
                messageInfo.zIndex = 2000 + this.MessageInfoList.length;

                this.MessageInfoList.push(messageInfo);

                if (!this.MessageCheckerRunning) {
                    this.MessageCheckerRunning = true;
                    setTimeout(
                        function () {
                            this.MessageChecker();
                        }.bind(this),
                        10
                    );
                }//end if (!this.MessageCheckerRunning) {

            },


            GetCenterWindowLayout(width, height) {
                let layout = new WindowLayout();
                //var dualScreenLeft = window.screenLeft != null ? window.screenLeft : screen.left;
                //var dualScreenTop = window.screenTop != null ? window.screenTop : screen.top;
                let browserWidth, browserHeight;

 
                browserWidth = this.GetBrowserWidth();
                browserHeight = this.GetBrowserHeight();

 
                layout.X = ((browserWidth / 2) - (width / 2));
                layout.Y = ((browserHeight / 2) + this.GetScrollTop() - (height / 2));

                layout.Width = width;
                layout.Height = height;

                return layout;
            },


            GetBrowserWidth() {
                var width;

                width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

                return width;
            },

            GetBrowserHeight() {
                var height;

                height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

                return height;
            },

            GetScrollTop() {
                var scrollTop = (
                    (document.documentElement && document.documentElement.scrollTop) ||
                    document.body.scrollTop
                );

                return scrollTop;
            },



            OnBeforeOpen(arg) {
                if (arg.params.Title != null) {
                    this.Title = arg.params.Title;
                }
                else {
                    this.Title = "訊息視窗";
                }

                this.Description = arg.params.Description;
                this.ConfirmHandler = arg.params.ConfirmHandler;
            },

            OnOpened() {

            },

            CssClass(messageInfo) {
                return messageInfo.State;
            }
        },

        computed: {

        },

        mounted() {
            document.body.insertAdjacentElement("BeforeEnd", this.$refs.MessageWindow);
        },

        beforeMounted() {

        },



        created() {

            this.$bus.$on('ShowMessage',
                function (arg) {
                    this.OnReceiveMessage(arg.Description, arg.Duration);
                }.bind(this)
            );

            this.$bus.$on('HideMessage',
                function (event) {

                    this.MessageInfoList.length = 0;
                }.bind(this)
            );
        },

        watch: {
            value: function (newVal, oldVal) {

            }
        }

        ,

        beforeDestroy: function () {

            this.$bus.$off('ShowMessage');
            this.$bus.$off('HideMessage');
        }


    }
</script>

<style>

    .MessageWindow {
        width: 100%;
        height: auto;
        min-height: 100px;
        max-width: 400px;
        background-color: white;
        border: 1px solid #999999;
        font-family: 微軟正黑體,Microsoft JhengHei,Zawgyi-one;
        position: absolute;
        z-index: 10;
        transform: translateY(40px);
        -webkit-transform: translateY(40px);
        opacity: 0;
        transition: all 0.1s ease-in;
        -webkit-transition: all 0.1s ease-in;
        -webkit-box-shadow: 0px 10px 16px -4px rgba(0,0,0,0.53);
        -moz-box-shadow: 0px 10px 16px -4px rgba(0,0,0,0.53);
        box-shadow: 0px 10px 16px -4px rgba(0,0,0,0.53);
        background-color: #f5f5f0;
    }

        .MessageWindow .Description {
            position: relative;
            display:block;
        }

        .MessageWindow.Showing {
            transform: translateY(0px);
            -webkit-transform: translateY(0px);
            opacity: 1;
        }

        .MessageWindow.FadeOut {
            transform: translateY(0px);
            -webkit-transform: translateY(0px);
            opacity: 0;
            transition: all 0.5s ease-in;
            -webkit-transition: all 0.5s ease-in;
        }
</style>
